// extracted by mini-css-extract-plugin
export default {"matchEventLinks":"TeamProfileTabs_matchEventLinks__I4WIf"};